module.exports = __webpack_public_path__ + "img/buy22.4657ecd5.jpg";